import ApiService from "./ApiService";

class SimplifiLeadService {
  getLeadList(queryString) {
    const endPoint = "simplifi-leads" + (queryString ? "?" + queryString : "");
    const inputData = {
      endPoint,
      addditionalHeaderData: {},
      postData: {},
    };
    return ApiService.getCall(inputData);
  }

  getLead(slug, queryString = "") {
    const endPoint =
      "simplifi-leads/" + slug + (queryString ? "?" + queryString : "");
    const inputData = {
      endPoint,
      addditionalHeaderData: {},
      postData: {},
    };
    return ApiService.getCall(inputData);
  }
}

export default new SimplifiLeadService();
